module.exports = __webpack_public_path__ + "media/images/guideline/F_03-345165b11cb412e24e331fc622032591.jpg";